import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  featureTutorials: null,
  bridebookInstitute: null,
  searchFilters: {
    venue: {
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'gardenOutdoor',
        'castle',
        'hotel',
        'cityHotelCityVenue',
        'warehouseFactory',
        'museumAttraction',
        'pubRestaurant',
        'golfCourse',
        'cruiseBoatYacht',
        'sportingVenueStadium',
        'conferenceCentre',
        'townHallRegistryOffice',
        'otherVenueType',
        'rooftop',
        'winery',
      ],
    },
  },
};

export default result;
